import { CSSObject } from '@chakra-ui/react';

export const BoxSectionWrapper: CSSObject = {
  my: ['0', null, '4'],
  mb: ['2', null, 'unset'],
  mt: 'unset',
  borderRadius: 'lg',
  bg: 'rgba(0, 209, 255, 0.25)',
  fontFamily: 'accent',
  boxShadow:
    '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
};

export const BoxWrapper: CSSObject = {
  padding: '11px',
};

export const TextHeading: CSSObject = {
  color: 'beta.300',
  fontSize: 'md',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  textShadow: '0px 0px 8px rgba(254, 208, 119, 0.5)',
};

export const ButtonViewMore: CSSObject = {
  bgGradient: 'linear(180deg, beta.300 0%, beta.400 100%)',
  color: 'beta.600',
  mr: '0',
  textAlign: 'center',
  fontSize: 'sm',
  fontWeight: 'semibold',
  textTransform: 'uppercase',
  width: 'full',
  boxShadow:
    '0px -3px 4px 0px rgba(0, 0, 0, 0.20) inset, 0px 4px 4px 0px rgba(255, 255, 255, 0.15) inset, 0px 4px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.30) inset',
  _hover: {
    opacity: 0.9,
  },
};
